import { HTMLAttributes } from 'react';

import { any, oneOf } from 'prop-types';

import { classMerge } from '@/utils/class-names';

export interface InputFieldButtonProps
	extends HTMLAttributes<HTMLButtonElement> {
	/**
	 * The icon for the button (e.g Eye).
	 *
	 * WARNING: Don't use tags for the icon just the imported name.
	 *
	 * example: <InputFieldButton .... icon={Home} />
	 */
	icon: any;
	/**
	 * The variant of the InputFieldButton (e.g leading)
	 */
	variant?: Variants;
}

type Variants = 'left' | 'right';

/**
 * InputFieldButton Library Component
 */
export const InputFieldButton = ({
	className,
	variant = 'right',
	icon: Icon,
	...props
}: InputFieldButtonProps) => (
	<button
		type="button"
		data-cy="InputFieldButton"
		{...props}
		className={classMerge(
			'flex-shrink-0',
			variant === 'left' && 'order-first',
			variant === 'right' && 'order-last',
			className
		)}
	>
		{Icon && (
			<Icon width="1.5em" height="1.5em" className="text-neutral-grey" />
		)}
	</button>
);

InputFieldButton.propTypes = {
	icon: any,
	variant: oneOf(['left', 'right']),
};
